import Vue from 'vue';
import VueGoogleMaps from 'gmap-vue';
import { initializeDatadog } from '../lib/datadog';
import { readMeta } from '../lib/page';
import { sendSegmentPageview } from '../lib/segment';
import { initGrowthbook } from '@/lib/growthbook';

const datadogStage = readMeta('datadog_stage');

if (datadogStage) {
  initializeDatadog(datadogStage);
}

/* eslint-disable */
declare global {
  interface Window {
    dataLayer: any[];
    analytics: any;
  }
}
/* eslint-enable */

window.dataLayer = window.dataLayer || [];

const Sittercity = Vue.extend({
  props: {
    skipSegmentPageEvent: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ssoUuid(): string | null {
      const ssoUuid = readMeta('account', 'data-account');
      if (ssoUuid == null) {
        return null;
      }
      return ssoUuid;
    },
    sessionID(): string | null {
      return readMeta('session');
    },
    siftKey(): string | null {
      return readMeta('sift');
    },
    trackSift(): string | null {
      return readMeta('track_sift');
    },
  },
  mounted() {
    if (this.$options.name && !this.skipSegmentPageEvent) {
      sendSegmentPageview(this.$options.name);
    }

    const script = document.querySelector('#_sift');
    if (this.ssoUuid && script && this.trackSift) {
      const u = this.ssoUuid;
      script.addEventListener('load', () => {
        const sift = (window as any)._sift;
        sift.push(['_setAccount', this.siftKey]);
        sift.push(['_setUserId', u]);
        sift.push(['_setSessionId', this.sessionID]);
        sift.push(['_trackPageview']);
      });
    }
  },
});

document.addEventListener('DOMContentLoaded', async () => {
  const googleMapsKey = readMeta('google_maps');

  if (googleMapsKey && googleMapsKey !== '') {
    Vue.use(VueGoogleMaps, {
      load: {
        key: googleMapsKey,
        libraries: ['drawing', 'places'],
      },
      installComponents: true,
    });
  }

  const e = document.createElement('script');
  e.src = 'https://cdn.siftscience.com/s.js';
  e.id = '_sift';
  document.body.appendChild(e);

  await initGrowthbook();
});

export default Sittercity;
